export default "__VITE_ASSET__MXaVwWUn__"